import { ListBox, Select } from "@heroui/react";
import { Controller, type Control } from "react-hook-form";
import type { RecipesFilterFormValues } from "../RecipesFilterContainer";
import { FilterFieldShell } from "./FilterFieldShell";

const HAS_MADE_IT_LABELS: Record<string, string> = {
    any: "Any",
    true: "I've made it",
    false: "Not tried yet"
};

interface HasMadeItFilterProps {
    control: Control<RecipesFilterFormValues>;
    onApply(): void;
}

export const HasMadeItFilter = ({ control, onApply }: HasMadeItFilterProps) => {
    return (
        <FilterFieldShell label="Made it?">
            <Controller
                name="hasMadeIt"
                control={control}
                render={({ field }) => {
                    const current = field.value?.[0] ?? "any";

                    return (
                        <Select
                            className="w-full"
                            variant="secondary"
                            placeholder="Any"
                            value={current}
                            onChange={(key) => {
                                field.onChange([key as string]);
                                // Defer apply to next tick so form state updates first.
                                queueMicrotask(onApply);
                            }}
                            aria-label="Have you made it?"
                        >
                            <Select.Trigger className="w-full">
                                <Select.Value>
                                    {({ defaultChildren, isPlaceholder, state }) => {
                                        const item = state.selectedItems[0];
                                        if (isPlaceholder || !item) return defaultChildren;
                                        return HAS_MADE_IT_LABELS[item.key as string] ?? item.textValue;
                                    }}
                                </Select.Value>
                                <Select.Indicator />
                            </Select.Trigger>
                            <Select.Popover>
                                <ListBox>
                                    <ListBox.Item id="any" textValue="Any">
                                        Any
                                        <ListBox.ItemIndicator />
                                    </ListBox.Item>
                                    <ListBox.Item id="false" textValue="Not tried yet">
                                        Not tried yet
                                        <ListBox.ItemIndicator />
                                    </ListBox.Item>
                                    <ListBox.Item id="true" textValue="I've made it">
                                        I've made it
                                        <ListBox.ItemIndicator />
                                    </ListBox.Item>
                                </ListBox>
                            </Select.Popover>
                        </Select>
                    );
                }}
            />
        </FilterFieldShell>
    );
};
